<template>
  <div class="d-flex align-items-center">
    <with-close-icon
      :class="'date-badge ' + dueDateBadge"
      :show-shadow-on-icon="true"
      icon-alignment="top"
      @close="$emit('clear')"
      v-if="value"
    >
      <span>{{ formatDate(value) }}</span>
    </with-close-icon>
    <span class="text-secondary pl-1 text-small-1" v-if="relativeDuration">{{
      relativeDuration
    }}</span>
  </div>
</template>

<script>
import WithCloseIcon from '@/components/WithCloseIcon.vue'
import { DATE_BADGE_MAP } from '@/constants/initiative'
import { formatDate } from '@/utils/formatDate'
import getDateBadge from '@/utils/getDateBadge'
import getInitiativeDateFieldRelativeDuration from '@/utils/initiative/getInitiativeDateFieldRelativeDuration'

/**
 * This shows the date value along with the days left/passed from that value.
 * e.g 16 Apr 5D
 */
export default {
  name: 'DateValue',
  props: {
    value: String,
    preventColorCoding: Boolean
  },
  components: {
    WithCloseIcon
  },
  data() {
    return {}
  },
  computed: {
    relativeDuration() {
      return getInitiativeDateFieldRelativeDuration(this.value)
    },
    dueDateBadge() {
      return this.preventColorCoding ? DATE_BADGE_MAP.default : getDateBadge(this.value)
    }
  },
  methods: {
    formatDate
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/components/badge';
</style>
